'use client'

import React, { useEffect, useState } from 'react'
import EventSlider from '@theme15/components/EventSlider'
import { EventBannerResponse, PromotionBannerResponse, SubPromotionBanner } from '@/services/dataTypes'

interface Props {
    domain: string
    banners: EventBannerResponse[] | PromotionBannerResponse[] | SubPromotionBanner[]
    eventName: string
}

const EventBanner = ({ domain, banners, eventName }: Props) => {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted || !banners?.length) return null

    return (
        <div className="relative overflow-hidden rounded-2xl shadow-md"
            style={{ border: '1px solid rgba(92,122,92,0.15)' }}>
            <EventSlider sliders={banners} domain={domain} eventName={eventName} />
        </div>
    )
}

export default EventBanner
